
<div class="row">
  <div class="col-2 section-label">
    <h6 class="m-0 ml-3">ที่อยู่จัดส่งเอกสาร</h6>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="required">ชื่อ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.firstname">
    <span class="text-danger" *ngIf="submitted && contact.firstname.trim().length == 0">
      กรุณาระบุ ชื่อ
    </span>
  </div>
  <div class="col-2 text-right">
    <label>นามสกุล</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.lastname">
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="required">เลขที่</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_homeno" >
    <span class="text-danger" *ngIf="submitted && contact.dpa_contact_homeno.trim().length == 0">
      กรุณาระบุ เลขที่
    </span>
  </div>
  <div class="col-2 text-right">
    <label>ถนน</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_street" >
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>หมู่ที่</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_moo" >
  </div>
  <div class="col-2 text-right">
    
  </div>
  <div class="col-3">
    
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label>ที่อยู่</label>
  </div>
  <div class="col-3">
    <select class="form-control select2">
      <option value="">เลือก</option>
      <option *ngFor="let sd of combinedAddressList" [value]="sd.id">
        {{sd.text}}
      </option>
    </select>
  </div>
  <div class="col-2 text-right">
    <label class="required">แขวง/ตำบล</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_subdistictname" readonly>
    <span class="text-danger" *ngIf="submitted && contact.dpa_contact_subdistictname.trim().length == 0">
      กรุณาระบุ แขวง/ตำบล
    </span>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="required">เขต/อำเภอ</label>
  </div>
  <div class="col-3">
      <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_distictname" readonly>
      <span class="text-danger" *ngIf="submitted && contact.dpa_contact_distictname.trim().length == 0">
        กรุณาระบุ เขต/อำเภอ
      </span>
  </div>
  <div class="col-2 text-right">
    <label class="required">จังหวัด</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_provincname" readonly>
    <span class="text-danger" *ngIf="submitted && contact.dpa_contact_provincname.trim().length == 0">
      กรุณาระบุ จังหวัด
    </span>
  </div>
</div>

<div class="row mt-3">
  <div class="col-2 text-right">
    <label class="required">รหัสไปรษณีย์</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_postcodename" readonly>
    <span class="text-danger" *ngIf="submitted && contact.dpa_contact_postcodename.trim().length == 0">
      กรุณาระบุ รหัสไปรษณีย์
    </span>
  </div>
  <div class="col-2 text-right">
    <label>ประเทศ</label>
  </div>
  <div class="col-3">
    <input type="text" class="form-control" [(ngModel)]="contact.dpa_contact_countryname" readonly>
  </div>
</div>

<hr class="mb-0">
<div class="row">
  <div class="col-2 section-label">
    <h6 class="m-0 ml-3">เอกสารที่ต้องการ</h6>
  </div>
</div>

<div class="row">
 &nbsp;
</div>

<div class="row mt-3" align="center">
  <div class="col-3">
    &nbsp;
  </div>
  <div class="col-6">
    <div class="card-body p-0">
      <table id="tbReqDocD03" style="width:100%" class="table table-bordered table-hover result-table">
        <thead>
          <tr>
            <th class="checkbox-col">
              <input type="checkbox" [(ngModel)]="isCheckedAll" (change)="onCheckAllChange()">
            </th>
            <th>เลขที่คำขอ</th>
            <th>ประเภทคำขอ</th> 
            <th>สถานะ</th>
            <th>สถานะการขอเอกสาร</th>
          </tr>
        </thead>
        <tbody style="background-color: white">
          <tr *ngFor="let c of contactDrosD03List; let i = index" id="{{c.RequestedNo}}">
            <td align="center" class="checkbox-col">
              <input type="checkbox" class="row-checker" value="{{c.RequestedNo}}" name="{{c.RequestedNo}}" *ngIf="c.isPrint != 1">
            </td>
            <td>{{c.RequestedNo}}</td>
            <td>{{c.RequestType}}</td> 
            <td>{{c.isPrintMessage}}</td>
            <td align="center">
              <button class="btn btn-info m-2" value="{{c.RequestedNo}}" (click)="openstatus(c.RequestedNo)" *ngIf="c.isPrint == 1">รายละเอียด</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="divNoData" class="row table-bordered bordernodata colhidden" style="background-color: white" >
        <div class="col-md-12 text-center">
          <label translate>ไม่พบข้อมูล</label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  &nbsp;
 </div>

<div class="row mt-5 mb-3">
  <div class="col-12 text-center">
    <button class="btn btn-info m-2" id="savedata" [disabled]="disablebtnSave"  (click)="save()">บันทึก</button>
    <button class="btn btn-info m-2" (click)="close()">ปิด</button>
  </div>
</div>

<!-- Modal detail-->
<div class="modal" [ngStyle]="{'display':displayStyle}"aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-m">
    <div class="modal-content">

      <div class="modal-body" style="background-color: #a7c4e6">

        <div class="row mt-3">
          <div class="col-12 text-center">
            <h5 class="modal-title" style="font-weight: bold">ยืนยันตัวตนผ่านรหัส OTP</h5>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            <label class="font-weight-bold">เบอร์โทรศัพท์</label>
          </div>
          <div class="col-6">
            <input type="text" class="form-control" [(ngModel)]="mobilemasking" >
          </div>
          <!-- <div class="col-4 input-group my-auto">
            <label style="font-size: 1.2rem;">OTP Ref:</label>
            <label style="font-size: 1.2rem;" class="text-danger">
              {{otpRef}}
            </label>
            <label class="ml-3">Password:</label>
            <input type="text" class="form-control" [(ngModel)]="verifyOtp">
            <button class="btn btn-primary" (click)="verify()" [disabled]="verifyOtp.trim().length == 0">
              Verify {{OTPCountDown}}
            </button>
          </div> -->
        </div>
        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            &nbsp;
          </div>
          <div class="col-3">
            <button class="btn btn-primary w-100" (click)="requestOtp()" [disabled]="disableResentOtp">
              ขอรหัส OTP 
            </button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            <label>OTP Ref:</label>
          </div>
          <div class="col-6">
            <label>
              {{otpRef}}
            </label>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            <label class="font-weight-bold">รหัส OTP</label>
          </div>
          <div class="col-6">
            <input type="text" class="form-control" [(ngModel)]="verifyOtp">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 offset-md-1 text-right">
            &nbsp;
          </div>
          <div class="col-3">
            <button class="btn btn-primary w-100" (click)="verify()" [disabled]="verifyOtp.trim().length == 0">
              ยืนยันรหัส OTP 
            </button>
          </div>
        </div>

        <div class="row mt-5 mb-2">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info" data-dismiss="modal" (click)="close()">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/customer-req-doc/customer-req-doc.component.html